export interface StateCapability {
  state: string;
  qm: boolean;
  nonQm: boolean;
}

function normalizeStateCode(value: unknown) {
  return typeof value === "string" ? value.trim().toUpperCase() : "";
}

/**
 * Keeps the new state-capability contract compatible with legacy profiles that
 * only contain LandingPageSetUp.States.
 *
 * Product confirmed that legacy licensed states support both categories until
 * the LO explicitly saves per-state capabilities. This mirrors the backend
 * rolling-deployment fallback.
 */
export function normalizeStateCapabilities(
  capabilities: StateCapability[] | undefined,
  legacyStates: string[] | undefined,
): StateCapability[] {
  const source: StateCapability[] =
    Array.isArray(capabilities) && capabilities.length
      ? capabilities
      : (Array.isArray(legacyStates) ? legacyStates : []).map((state) => ({
          state,
          qm: true,
          nonQm: true,
        }));

  const seen = new Set<string>();

  return source.reduce<StateCapability[]>((result, item) => {
    const state = normalizeStateCode(item?.state);
    if (!state || seen.has(state)) return result;

    seen.add(state);
    result.push({
      state,
      qm: Boolean(item?.qm),
      nonQm: Boolean(item?.nonQm),
    });
    return result;
  }, []);
}

export function stateCodesFromCapabilities(capabilities: StateCapability[]) {
  return normalizeStateCapabilities(capabilities, []).map(({ state }) => state);
}
